// icons are from https://github.com/madebybowtie/FlagKit

import { CountryCode } from 'libphonenumber-js'

import RU from './flags/ru.png'
import US from './flags/us.png'
import CA from './flags/ca.png'
import ES from './flags/es.png'
import GB from './flags/gb.png'
import EU from './flags/eu.png'

export default {
  RU,
  US,
  CA,
  ES,
  GB,
  EU,
} as Record<CountryCode | 'EU', string>
